<template>
  <div>
    <b-row>
      <!-- main -->
      <b-col cols="4">
        <h2>Просмотр контакта</h2>
        <back-button :to="{name: 'Contacts'}"/>

        <b-form @submit="onSubmit" size="sm">
          <b-form-group label="Имя">
            <b-form-input
              v-model="contact.first_name"
              type="text"
            ></b-form-input>
          </b-form-group>

          <b-form-group label="Отчество">
            <b-form-input
              v-model="contact.middle_name"
              type="text"
            ></b-form-input>
          </b-form-group>

          <b-form-group label="Фамилия">
            <b-form-input
              v-model="contact.last_name"
              type="text"
            ></b-form-input>
          </b-form-group>

          <b-form-group label="Теги">
            <tags v-bind:value="contact.tags"
                  v-on:input="contact.tags = $event"></tags>
          </b-form-group>

          <b-card no-body>
            <b-tabs card>
              <b-tab title="Основное">
                <b-card-text>
                  <b-form-group label="Телефон:">
                    <b-input-group>
                      <b-form-input
                        v-model="contact.phone"
                        type="text"
                      ></b-form-input>
                      <b-input-group-append>
                        <b-button variant="primary" title="Позвонить" v-on:click="callSipuni">
                          <b-icon-headphones></b-icon-headphones>
                        </b-button>
                      </b-input-group-append>
                    </b-input-group>
                  </b-form-group>
                  <b-form-group label="E-mail">
                    <b-form-input
                      v-model="contact.email"
                      type="email"
                    ></b-form-input>
                  </b-form-group>
                  <p v-if="contact.chat_id">
                    <b-icon-chat size="sm"></b-icon-chat>
                    <a :href="'https://crm-telegram.hyper-script.ru/chat/'+contact.chat_id" target="_blank" class="ml-1"> Чат в Telegram</a>
                  </p>
                  <p v-if="contact.metaData && contact.metaData.yandexMetrikaClientId" title="Yandex Metrika ClientID">
                    <b-icon-bar-chart size="sm"></b-icon-bar-chart>
                    <span class="ml-1">Яндекс Метрика ClientID: {{ contact.metaData.yandexMetrikaClientId }}</span>
                  </p>
                  <b-form-group label="Дата рождения:">
                    <date-picker
                      v-model="contact.birth_date"
                      placeholder="Выберите дату"
                      :lang="datepicker.lang"
                      :format="datepicker.format"
                      :value-type="datepicker.valueType"
                    />
                  </b-form-group>

                  <b-form-group label="Компания:" class="bold">
                    <company-list-entry :company="contact.company"></company-list-entry>
                  </b-form-group>

                  <b-form-group label="Связанные контакты:" class="bold">
                    <contacts v-model="contact.contacts" v-on:input="contact.contacts=$event"></contacts>
                  </b-form-group>

                </b-card-text>
              </b-tab>
              <b-tab title="Сделки">
                <b-card-text>
                  <b-form-group>
                    <deals v-model="contact.deals" v-on:input="contact.deals=$event"></deals>
                  </b-form-group>
                </b-card-text>
              </b-tab>
<!--              <b-tab title="Академия">-->
<!--                <b-card-text>-->
<!--                </b-card-text>-->
<!--              </b-tab>-->
            </b-tabs>
          </b-card>


          <br/>

          <loading-button :is-busy="isBusy"></loading-button>
        </b-form>
      </b-col>
      <!-- comments -->
      <b-col cols="8" class="comments-box">
        <comments :entity="contact" entity-type="contact"></comments>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import Tags from "../components/tags";
import Contacts from "../components/ContactsAssignable";
import LoadingButton from "../components/LoadingButton";
import BackButton from "../components/BackButton";
import CompanyListEntry from "../components/CompanyListEntry";
import Deals from "../components/Deals";
import Comments from "../components/Comments";
import datapickerMixin from '../mixins/datapicker';
import common from "@/mixins/common";

export default {
  name: "Contact",
  components: {Comments, Deals, CompanyListEntry, BackButton, LoadingButton, Contacts, Tags},
  mixins: [datapickerMixin, common],
  data() {
    return {
      isBusy: false,
      totalRows: 1,
      errorResult: null,
      messageResult: '',
      perPage: 20,
      currentPage: 1,
      error: false,
      message: '',
      items: [],
      contact: {
        id: 0,
        first_name: '',
        last_name: '',
        middle_name: '',
        phone: '',
        email: '',
        birth_date: '',
        tags: [],
        company: {}
      },
    }
  },
  mounted() {
    this.fetchContact();
  },
  methods: {
    fetchContact() {
      this.error = false;
      this.isBusy = true;
      this.axios.get(process.env.VUE_APP_BACKEND_URL + '/api/contacts/' + this.$route.params.id, {}
      ).then((response) => {
        if (response) {
          if (response.data.error === false) {
            this.error = false;
            this.contact = response.data.contact
            if (this.contact.tags === null || this.contact.tags === undefined) {
              this.contact.tags = [];
            }
            if (this.contact.phone)
              this.contact.phone = this.formatPhone(this.contact.phone);
            this.isBusy = false;
          } else {
            this.error = true;
            this.message = response.data.message;
            this.isBusy = false;
          }
        }
      })
    },
    submitSearch() {

    },
    callSipuni() {
      this.axios.get(process.env.VUE_APP_BACKEND_URL + '/api/sipuni/' + this.contact.phone, {})
        .then((response) => {
          this.isBusy = false;
          if (response) {
            if (response.data.success === true) {
              this.$bvToast.toast('Звоним на номер ' + this.contact.phone, {
                title: 'Исходящий звонок',
                autoHideDelay: 30000,
                appendToast: true,
                variant: 'success',
              });
            } else {
              console.log(response);
              this.$bvToast.toast(response.data.message , {
                title: 'Исходящий звонок',
                autoHideDelay: 30000,
                appendToast: true,
                variant: 'danger',
              });
            }
          }
        })
        .catch((error) => {
          this.isBusy = false;
          console.log(error);
        });
    },
    onSubmit(evt) {
      evt.preventDefault();
      this.error = false;
      this.isBusy = true;
      this.axios.post(process.env.VUE_APP_BACKEND_URL + '/api/contacts/' + this.contact.id, JSON.stringify(this.contact)
      ).then((response) => {
        this.isBusy = false;
        if (response) {
          if (response.data.error === false) {
            this.error = false;

          } else {
            this.error = true;
            this.message = response.data.message;
          }
        }
      }).catch((error) => {
        this.isBusy = false;
        console.log(error);
      });
    },
  }
}
</script>

<style scoped>
.comments-box {
  height: 100vh;
  border-left: 1px solid #ccc;
}

.bold >>> legend {
  font-weight: 500;
}
</style>
